var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWsB2BIconActiveUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.78,
    height: 33.78,
    viewBox: "0 0 33.78 33.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.89,18.55h0A7,7,0,1,1,22.71,7.67a6.88,6.88,0,0,1,1.17,3.88,7,7,0,0,1-7,7Zm0-12a5.31,5.31,0,0,0-1,.09,5,5,0,0,0,1,9.9,5,5,0,0,0,5-5A5,5,0,0,0,18.8,6.94,5,5,0,0,0,16.89,6.56Z",
    transform: "translate(0 0)",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25,29.71h-2V24.43a6.74,6.74,0,0,1,6.59-6.78l0,2a4.75,4.75,0,0,0-4.63,4.78Zm19.29,0h-2V24.43a4.76,4.76,0,0,0-4.64-4.78l.05-2a6.76,6.76,0,0,1,6.59,6.78Z",
    transform: "translate(0 0)",
    fill: "red"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.89,21.36a6,6,0,0,1-2.41-.49,6.2,6.2,0,0,1-2-1.4.66.66,0,0,0,.2.14.49.49,0,0,0,.24,0l-.06-2a1.28,1.28,0,0,1,.58.11,1.22,1.22,0,0,1,.48.33,4.18,4.18,0,0,0,6,0,1.34,1.34,0,0,1,.48-.34,1.47,1.47,0,0,1,.62-.1l-.14,2a.9.9,0,0,0,.28,0,.64.64,0,0,0,.19-.13,6.15,6.15,0,0,1-4.43,1.88Z",
    transform: "translate(0 0)",
    fill: "red"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.89,33.78A16.89,16.89,0,1,1,33.78,16.89,16.91,16.91,0,0,1,16.89,33.78ZM16.89,2A14.89,14.89,0,1,0,31.78,16.89,14.91,14.91,0,0,0,16.89,2Z",
    transform: "translate(0 0)",
    fill: "red"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsB2BIconActiveUsers);
export default __webpack_public_path__ + "static/media/ws-b2b-icon-active-users.c2f6914e38e7024d246ffed205fa920c.svg";
export { ForwardRef as ReactComponent };